/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageSeriesDate/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Simple/Data/format.js'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'



/** @type {import('Simple/types.js').View} */
export default function ImageSeriesDate({
  children,
  viewPath = "/DesignSystem/ImageViewer/ImageSeriesDate"
  
}) {
let constantData = 'Series:'
let viewerImageSeriesSeriesDateValueData = fromData.useDataFormat({ viewPath,
context: 'viewer',
path: 'image_series.series_date',
format: fromFormat.dateISOIn,
})
let aggregateData = fromAggregate.join(constantData, viewerImageSeriesSeriesDateValueData)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 marginLeft={dtSpaceS}
 data="'Series:'"
 data="viewer.image_series.series_date"
 format="/Simple/Data/format.js dateISOIn"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}